export default "__VITE_ASSET__be2920c8__"